import {
  ActivityChangeOptions,
  ActivityUserItem,
} from '@spotify/plugin-confidence-activity-react';
import {
  ISSUE_ACTIVITY_TYPES,
  createIssueUpdatesChangeExtension,
} from '@spotify/plugin-confidence-issues-react';

import { isIssueActivityType } from './issueActivityUtils';

const IssueAssigneeChangeRender = ({ change }: ActivityChangeOptions) => (
  <ActivityUserItem
    oldValue={typeof change.oldValue === 'string' ? change.oldValue : undefined}
    newValue={typeof change.newValue === 'string' ? change.newValue : undefined}
  />
);

export const ISSUE_ASSIGNEE_CHANGE_EXTENSION =
  createIssueUpdatesChangeExtension({
    id: 'issue-assignee-change',
    priority: 10,
    predicate: options =>
      isIssueActivityType(
        options.activity,
        ISSUE_ACTIVITY_TYPES.assignmentChanged,
      ) && options.change.fieldPath === '/assignee',
    render: IssueAssigneeChangeRender,
  });
